module.exports = __webpack_public_path__ + "static/media/background2.2e065b5a.png";